import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import GalleryPage from './pages/GalleryPage';
import StatsPage from './pages/StatsPage';
import { Toaster } from '@/components/ui/sonner';
import MemberSelector from './components/MemberSelector';
import InstallAppButton from './components/InstallAppButton';
import NotificationPrompt from './components/NotificationPrompt';
import './App.css';

function App() {
  const [currentMember, setCurrentMember] = useState(null);

  useEffect(() => {
    // Check if member is stored in localStorage
    const storedMember = localStorage.getItem('currentMember');
    if (storedMember) {
      setCurrentMember(storedMember);
    }

    // Register service worker for PWA and handle updates
    if ('serviceWorker' in navigator) {
      // Unregister old service workers first (to clear bad cache)
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          if (registration.active && registration.active.scriptURL.includes('service-worker')) {
            // Check if it's an old version by trying to update
            registration.update();
          }
        }
      });
      
      // Register new service worker
      navigator.serviceWorker
        .register('/service-worker.js', { updateViaCache: 'none' })
        .then((registration) => {
          console.log('Service Worker registered:', registration);
          
          // Check for updates every time
          registration.update();
          
          // Handle updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'activated') {
                  console.log('New service worker activated');
                  // Optionally reload page to get fresh content
                  // window.location.reload();
                }
              });
            }
          });
        })
        .catch((error) => {
          console.log('Service Worker registration failed:', error);
        });
    }
  }, []);

  const handleSelectMember = (memberName) => {
    setCurrentMember(memberName);
    localStorage.setItem('currentMember', memberName);
  };

  const handleLogout = () => {
    setCurrentMember(null);
    localStorage.removeItem('currentMember');
  };

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <InstallAppButton />
      {!currentMember ? (
        <MemberSelector onSelectMember={handleSelectMember} />
      ) : (
        <>
          <NotificationPrompt currentMember={currentMember} />
          <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={<HomePage currentMember={currentMember} onLogout={handleLogout} />}
              />
              <Route
                path="/gallery"
                element={<GalleryPage currentMember={currentMember} onLogout={handleLogout} />}
              />
              <Route
                path="/stats"
                element={<StatsPage currentMember={currentMember} onLogout={handleLogout} />}
              />
            </Routes>
          </BrowserRouter>
        </>
      )}
    </div>
  );
}

export default App;